export const SECTIONS = [
  {
    title: 'Connectivity',
    fields: [
      { key: 'bluetoothID', label: 'Bluetooth ID' },
      { key: 'uid', label: 'UID' },
      { key: 'vendorID', label: 'Vendor ID' },
      { key: 'productID', label: 'Product ID' },
      { key: 'formatID', label: 'Format ID' }
    ]
  },
  {
    title: 'Hardware',
    fields: [
      { key: 'serialNumber', label: 'Serial number' },
      { key: 'hardwareID', label: 'Hardware ID' },
      { key: 'hardwareVersion', label: 'Hardware version' },
      { key: 'bID', label: 'B ID' }
    ]
  },
  {
    title: 'Firmware & SDK',
    fields: [
      { key: 'firmwareID', label: 'Firmware ID' },
      { key: 'firmwareVersion', label: 'Firmware version' },
      { key: 'bootloaderVersion', label: 'Bootloader version' },
      { key: 'sdkVersion', label: 'SDK version' },
      { key: 'deviceSettingVersion', label: 'Device setting version' },
      { key: 'terminalSettingVersion', label: 'Terminal setting version' }
    ]
  },
  {
    title: 'Capabilities',
    fields: [
      { key: 'isSupportedTrack1', label: 'Track 1', format: 'bool' },
      { key: 'isSupportedTrack2', label: 'Track 2', format: 'bool' },
      { key: 'isSupportedTrack3', label: 'Track 3', format: 'bool' },
      { key: 'isSupportedNfc', label: 'NFC', format: 'bool' },
      { key: 'isSupportedSoftwarePinPad', label: 'Software PIN pad', format: 'bool' }
    ]
  },
  {
    title: 'Key profiles & KSNs',
    permission: 'myriad_lab.access',
    fields: [
      { key: 'trackKeyProfileID', label: 'Track key profile' },
      { key: 'trackKsn', label: 'Track KSN' },
      { key: 'pinKeyProfileID', label: 'PIN key profile' },
      { key: 'pinKsn', label: 'PIN KSN' },
      { key: 'macKeyProfileID', label: 'MAC key profile' },
      { key: 'macKsn', label: 'MAC KSN' },
      { key: 'emvKeyProfileID', label: 'EMV key profile' },
      { key: 'emvKsn', label: 'EMV KSN' }
    ]
  }
];
